import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface DeliverableCompletedProgressionActionsProps {
  canCompleteJob?: boolean
  onCompleteJob: () => unknown
}

export function DeliverableCompletedProgressionActions({
  canCompleteJob,
  onCompleteJob,
}: DeliverableCompletedProgressionActionsProps) {
  return (
    <CardContent>
      <Button
        label="Complete Job"
        variant="primary"
        size="wide-slim"
        onPress={onCompleteJob}
        testId="job-progression-complete-job-button"
        isDisabled={!canCompleteJob}
      />
    </CardContent>
  )
}
